import { StepStatus } from '@/models/step.model';

export const finalStatuses = [StepStatus.COMPLETED, StepStatus.CANCELED, StepStatus.IN_PROGRESS];
